import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ProgramsPage } from './pages/ProgramsPage';
import { KidsMartialArtsPage } from './pages/programs/KidsMartialArtsPage';
import { TeenAdultClassesPage } from './pages/programs/TeenAdultClassesPage';
import { BrazilianJiuJitsuPage } from './pages/programs/BrazilianJiuJitsuPage';
import { CompetitionTeamPage } from './pages/programs/CompetitionTeamPage';
import { BlackBeltClubPage } from './pages/BlackBeltClubPage';
import { LocationsPage } from './pages/LocationsPage';
import { InstructorsPage } from './pages/InstructorsPage';
import { FormsVideosPage } from './pages/FormsVideosPage';
import { FAQsPage } from './pages/FAQsPage';
import { ContactPage } from './pages/ContactPage';
import { MerchPage } from './pages/MerchPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { MidlandPage } from './pages/locations/MidlandPage';
import { SaginawPage } from './pages/locations/SaginawPage';
import { CaroPage } from './pages/locations/CaroPage';
import { BridgeportPage } from './pages/locations/BridgeportPage';
import { HemlockPage } from './pages/locations/HemlockPage';
import { BayCityPage } from './pages/locations/BayCityPage';
function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/programs" element={<ProgramsPage data-id="element-5" />} data-id="element-4" />
        <Route path="/programs/kids-martial-arts" element={<KidsMartialArtsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/programs/teen-adult-classes" element={<TeenAdultClassesPage data-id="element-9" />} data-id="element-8" />
        <Route path="/programs/brazilian-jiu-jitsu" element={<BrazilianJiuJitsuPage data-id="element-11" />} data-id="element-10" />
        <Route path="/programs/competition-team" element={<CompetitionTeamPage data-id="element-13" />} data-id="element-12" />
        <Route path="/black-belt-club" element={<BlackBeltClubPage data-id="element-15" />} data-id="element-14" />
        <Route path="/locations" element={<LocationsPage data-id="element-17" />} data-id="element-16" />
        <Route path="/locations/midland" element={<MidlandPage data-id="element-19" />} data-id="element-18" />
        <Route path="/locations/saginaw" element={<SaginawPage data-id="element-21" />} data-id="element-20" />
        <Route path="/locations/caro" element={<CaroPage data-id="element-23" />} data-id="element-22" />
        <Route path="/locations/bridgeport" element={<BridgeportPage data-id="element-25" />} data-id="element-24" />
        <Route path="/locations/hemlock" element={<HemlockPage data-id="element-27" />} data-id="element-26" />
        <Route path="/locations/bay-city" element={<BayCityPage data-id="element-29" />} data-id="element-28" />
        <Route path="/instructors" element={<InstructorsPage data-id="element-31" />} data-id="element-30" />
        <Route path="/forms-videos" element={<FormsVideosPage data-id="element-33" />} data-id="element-32" />
        <Route path="/faqs" element={<FAQsPage data-id="element-35" />} data-id="element-34" />
        <Route path="/contact" element={<ContactPage data-id="element-37" />} data-id="element-36" />
        <Route path="/merch" element={<MerchPage data-id="element-39" />} data-id="element-38" />
        <Route path="/merch/:productId" element={<ProductDetailPage data-id="element-41" />} data-id="element-40" />
      </Routes>
    </Router>;
}
export { App };